"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionGroup = void 0;
const a_entity_group_1 = require("./a-entity-group");
const entity_component_store_1 = require("../entity-component-store");
/**
 * @public
 * {@inheritDoc IInteractionGroup}
 */
class InteractionGroup extends a_entity_group_1.AEntityGroup {
    constructor(groupMask, hitTestableGroup, plot) {
        super();
        this.plot = plot;
        this.entitiesInGroup = new Set();
        this.hitAllowedComponentStore = new entity_component_store_1.EntityComponentStore();
        this.groupMask = groupMask;
        this.hitTestableGroup = hitTestableGroup;
    }
    addToGroup(entity, options) {
        this.plot.addToGroup(entity, this, options);
    }
    onEntityAdded(entity, options) {
        this.hitTestableGroup.refCountingAddEntity(entity, options);
        this.hitAllowedComponentStore.setComponent(entity, options.hitAllowedComponent);
        entity.groupMask |= this.groupMask;
        this.entitiesInGroup.add(entity);
    }
    onEntityRemoved(entity) {
        // remove the mask without touching the others
        entity.groupMask &= ~this.groupMask;
        this.entitiesInGroup.delete(entity);
        this.hitTestableGroup.refCountingRemoveEntity(entity);
        this.hitAllowedComponentStore.deleteComponent(entity);
    }
}
exports.InteractionGroup = InteractionGroup;
//# sourceMappingURL=interaction-group.js.map